import { render, staticRenderFns } from "./detail-service.vue?vue&type=template&id=065f93c0&scoped=true&"
import script from "./detail-service.vue?vue&type=script&lang=js&"
export * from "./detail-service.vue?vue&type=script&lang=js&"
import style0 from "./detail-service.vue?vue&type=style&index=0&id=065f93c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065f93c0",
  null
  
)

export default component.exports